import api from './api';
import { AITaskCost, AITaskCostCreate, AITaskCostUpdate } from '../schemas/aiTaskCost';

const aiTaskCostService = {
  getAllAITaskCosts: async (): Promise<AITaskCost[]> => {
    const response = await api.get<AITaskCost[]>('/ai-task-costs/');
    return response.data;
  },

  createAITaskCost: async (data: AITaskCostCreate): Promise<AITaskCost> => {
    const response = await api.post<AITaskCost>('/ai-task-costs/', data);
    return response.data;
  },

  updateAITaskCost: async (taskType: string, data: AITaskCostUpdate): Promise<AITaskCost> => {
    const response = await api.put<AITaskCost>(`/ai-task-costs/${taskType}`, data);
    return response.data;
  },

  deleteAITaskCost: async (taskType: string): Promise<void> => {
    await api.delete(`/ai-task-costs/${taskType}`);
  },
};

export default aiTaskCostService;
